export default function OpenInNew({ className = "" }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      className={className}>
      <path
        d="M4.5 21C4.1 21 3.75 20.85 3.45 20.55C3.15 20.25 3 19.9 3 19.5V4.5C3 4.1 3.15 3.75 3.45 3.45C3.75 3.15 4.1 3 4.5 3H9.475V4.5H4.5V19.5H19.5V14.525H21V19.5C21 19.9 20.85 20.25 20.55 20.55C20.25 20.85 19.9 21 19.5 21H4.5ZM9.55 15.525L8.5 14.45L18.45 4.5H12.975V3H21V11.025H19.5V5.575L9.55 15.525Z"
        fill="black"
      />
    </svg>
  )
}
